import { useState } from "react"
import { Button, Card, Col, Flex, Row } from "antd"
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import { useDevice } from "hooks/useDevice"
import AddTaxFeeModal from "../AddTaxFeeModal"
import styles from "./TaxesAndFees.module.css"

const TaxesAndFees = ({ fees, onAdd, onDelete }) => {
  const { t } = useTranslation()
  const { isMobile } = useDevice()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleAdd = (selected) => {
    onAdd(selected)
    setIsModalOpen(false)
  }

  return (
    <>
      <Card
        style={{ border: "1.5px solid var(--color-lines)", borderRadius: "var(--border-radius-m)" }}
        styles={{ body: { padding: "var(--spacing-xl) var(--spacing-3xl) var(--spacing-3xl)" } }}
      >
        <Flex align="center" gap={16} className={styles.cardHeader}>
          <Text className={styles.sectionTitle}>{t("experiences.pricing.taxes_and_fees.title")}</Text>
          <Button type="primary" shape="round" size="large" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
            {isMobile
              ? t("common.add")
              : t("experiences.pricing.taxes_and_fees.add_button")}
          </Button>
        </Flex>

        <WithEmptyStateWrapper
          name="tax"
          tag="div"
          hasItems={fees.length > 0}
          fallbackButtonText={t("experiences.pricing.taxes_and_fees.title")}
          fallbackButtonClickHandler={() => setIsModalOpen(true)}
        >
          <Row gutter={[8, 8]}>
            {fees.map((fee) => (
              <Col key={fee.id} span={24} md={12}>
                <Flex align="center" gap={12} className={styles.feeItem}>
                  <Text className={styles.feeName}>{fee.title}</Text>
                  <Text className={styles.feeValue}>{fee.fee_type === "percentage" ? `${fee.price}%` : `$${fee.price}`}</Text>
                  <Button
                    type="text"
                    icon={<DeleteOutlined />}
                    className={styles.deleteBtn}
                    onClick={() => onDelete(fee.id)}
                  />
                </Flex>
              </Col>
            ))}
          </Row>
        </WithEmptyStateWrapper>
      </Card>

      <AddTaxFeeModal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onAdd={handleAdd}
        existingFeeIds={fees.map((fee) => fee.id)}
      />
    </>
  )
}

TaxesAndFees.propTypes = {
  fees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      fee_type: PropTypes.string.isRequired,
    })
  ).isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default TaxesAndFees
